<template>
  <div class="flex flex-direction" id="bigView">
    <Title :ch="'大咖观点'" :bg-img="titleBgImg"></Title>
    <div class="bigView-container">
      <div
        class="bigView_list flex align-center"
        :class="{
          'swiper-no-swiping': !$store.state.isMobile,
        }"
      >
        <div
          :class="{
            'swiper-container-bigView-wap': $store.state.isMobile,
            'swiper-container-bigView': !$store.state.isMobile,
          }"
        >
          <div class="swiper-wrapper flex">
            <div
              class="swiper-slide flex flex-direction justify-between"
              @mouseenter="now_swiper = index"
              v-for="(bigView, index) in bigViews"
              :key="index"
              :data-index="index"
            >
              <div class="big-view-info-box">
                <div class="name">{{ bigView.title }}</div>
                <div class="red-line"></div>
                <div
                  v-if="$store.state.isMobile"
                  class="position"
                  v-html="
                    bigView.position.replace(
                      '华为数据存储与机器视觉产品线总裁',
                      '华为数据存储与机器视觉<br>产品线总裁'
                    )
                  "
                ></div>
                <div v-else class="position" v-html="bigView.position"></div>
                <div class="viewpoint">{{ bigView.viewpoint }}</div>
                <div class="bottom"></div>
                <img class="photo" :src="bigView.coverImageUrl_new" />
              </div>
            </div>
          </div>
          <div
            class="swiper-pagination-bigView flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div
          class="swiper-button-prev big-view-prev cs"
          v-if="
            $store.state.isMobile ||
            (bigViews.length > 2 && !this.$store.state.isMobile)
          "
        >
          <img :src="ArrowUrl" />
        </div>
        <div
          class="swiper-button-next big-view-next cs"
          v-if="
            $store.state.isMobile ||
            (bigViews.length > 2 && !this.$store.state.isMobile)
          "
        >
          <img :src="ArrowUrl" />
        </div>
      </div>
    </div>
    <DidLink @click.native="lookMore"></DidLink>
  </div>
</template>

<script>
import Title from "./common/Title";
import { Swiper } from "vue-awesome-swiper";
let self;
export default {
  name: "BigView",
  data() {
    return {
      titleBgImg: require("../assets/images/bigView/home/title.png"),
      ArrowUrl: require("../assets/images/videos/arrow.png"),
      bigViews: [],
      swiper_video_pc: null,
      now_swiper: 2,
      swiper_big_view: null,
    };
  },
  components: {
    Title,
  },
  mounted() {
    self = this;
    //获取大咖观点
    this.getBigViews();
    // this.$bus.$on("reSwiper", (res) => {
    //   //初始化 swiper 方法 ↓
    //   this.swiper_big_view.init();
    // });
  },
  methods: {
    getBigViews() {
      this.$api
        .getStaticData(this.$config.bigViewId)
        .then((res) => {
          if (res.result == 0) {
            let bigviews = res.content.items;
            bigviews = bigviews
              .filter((item) => {
                return item.isTop == 1;
              })
              .sort(function (a, b) {
                return a.order - b.order;
              });
            for (let i = 0; i < bigviews.length; i++) {
              bigviews[i].coverImageUrl_new = "";
              if (bigviews[i].coverImageRealPath) {
                bigviews[i].coverImageUrl_new = bigviews[
                  i
                ].coverImageRealPath.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              bigviews[i].position = bigviews[i].summary.substring(
                0,
                bigviews[i].summary.indexOf("SWITCH")
              );
              bigviews[i].viewpoint = bigviews[i].summary.substring(
                bigviews[i].summary.indexOf("SWITCH") + 6,
                bigviews[i].summary.length
              );
            }
            this.bigViews = bigviews.sort((a, b) => {
              return b.order - a.order;
            });

            if (this.$store.state.isMobile) {
              this.$nextTick(() => {
                // 初始化swiper
                this.loadSwiper();
              });
            } else {
              this.$nextTick(() => {
                // 初始化swiper
                this.swiper_video_pc = new Swiper(".swiper-container-bigView", {
                  loop: false, //首尾循环
                  centeredSlides: false,
                  slidesPerView: 2, //每组 有多少块
                  loopedSlides: 10,
                  spaceBetween: 40, //板块间隔
                  slidesPerGroup: 1, //多少个板块为1组。
                  navigation: {
                    nextEl: ".big-view-next",
                    prevEl: ".big-view-prev",
                    disabledClass: "big-view-button-disable",
                  },
                  resistanceRatio: 0,
                  on: {},
                });
              });
            }
          }
        })
        .catch((err) => {
          console.log("获取大咖观点失败", err);
        });
    },
    loadSwiper() {
      this.swiper_big_view = new Swiper(".swiper-container-bigView-wap", {
        loop: true, //首尾循环
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-bigView",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active2",
        },
      });
    },
    lookMore() {
      window._hw("send", "action", "index_check_more_all_click", {
        module_name: "大咖观点",
      });
      this.$router.push({
        path: "/bigview",
      });
    },
    handleInvite(e, idx) {
      if (e.path[1].attributes[3]) {
        this.now_swiper = e.path[1].attributes[3].nodeValue;
      } else {
        this.now_swiper = e.path[2].attributes[3].nodeValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// bigView begin
#bigView {
  width: 100%;
}
// bigView end
@media screen and (min-width: 992px) {
  #bigView {
    width: 100%;
    padding: 60px 160px 60px 160px;
    .bigView-container {
      width: 1600px;
      height: 468px;
      .bigView_list {
        width: 1600px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        .swiper-button-prev {
          width: 50px;
          height: 50px;
          background: #151e26;
          opacity: 0.24;
          position: absolute;
          left: 1450px;
          top: -50px;
          border-radius: 50%;
          line-height: 69px;
          text-align: center;
          &::after {
            content: "";
          }
          img {
            width: 20px;
            height: 12px;
            transform: rotate(90deg);
          }
        }
        .swiper-button-prev:hover {
          background-color: rgba(180, 37, 30, 1);
        }
        .swiper-button-next {
          width: 50px;
          height: 50px;
          opacity: 0.24;
          position: absolute;
          top: -50px;
          right: 0px;
          background-color: #151e26;
          border-radius: 50%;
          line-height: 69px;
          text-align: center;
          &::after {
            content: "";
          }
          img {
            width: 20px;
            height: 12px;
            transform: rotate(270deg);
          }
        }
        .swiper-button-next:hover {
          background-color: rgba(180, 37, 30, 1);
        }
        .big-view-button-disable {
          background-color: #151e26;
          cursor: not-allowed;
        }
        .big-view-button-disable:hover {
          background-color: #151e26;
        }
        ::v-deep .swiper-container-bigView,
        swiper-container-initialized,
        swiper-container-horizontal {
          width: 1600px;
          height: 100%;
          position: relative;
          overflow: hidden;

          .swiper-wrapper {
            height: 100%;
            width: 100%;

            .swiper-slide {
              height: 100%;
              width: 100%;
              position: relative;

              .big-view-info-box {
                overflow: hidden;
                width: 768px;
                height: 468px;
                padding-top: 58px;
                padding-left: 62px;
                background: url("../assets/images/bigView/bg-pc.png"),
                  url("../assets/images/bigView/bg-pc-kv.png");
                background-position: 0 0, top right;
                background-repeat: no-repeat, no-repeat;
                background-size: 100% 100%, 566px 234px;
                position: relative;
                .bottom {
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  width: 441px;
                  height: 204px;
                  background: url("../assets/images/bigView/bottom-bg-pc.png");
                  background-position: 0 0;
                  background-repeat: no-repeat;
                  background-size: 441px 204px;
                  z-index: 2;
                }
                .photo {
                  width: 300px;
                  position: absolute;
                  right: 2px;
                  bottom: 0;
                  z-index: 1;
                }
                .name {
                  font-size: 32px;
                  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                  font-weight: bold;
                  color: #333333;
                }
                .red-line {
                  margin-top: -10px;
                  width: 104px;
                  height: 5px;
                  background: #b4251e;
                  margin-bottom: 13px;
                }
                .position {
                  font-size: 18px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  margin-bottom: 23px;
                }
                .viewpoint {
                  width: 410px;
                  height: 288px;
                  overflow-y: auto;
                  text-align: justify;
                  word-break: break-all;
                  text-justify: distribute;
                  font-size: 16px;
                  padding-right: 10px;
                  &::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
                    height: 1px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  #bigView {
    width: 100%;
    padding-top: 143px;
    .bigView-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 686px;
      .bigView_list {
        width: 100%;
        height: 686px;
        margin: 0 auto;
        position: relative;
        .swiper-button-prev,
        .swiper-button-next {
          display: none;
        }
        ::v-deep .swiper-container-bigView-wap {
          width: 100%;
          height: 100%;
          position: relative;
          .swiper-wrapper {
            width: 100%;
            height: calc(100% - 50px);
            display: flex;
            .swiper-slide {
              width: 74% !important;
              width: 100%;
              height: 100%;
              transform: translate3d(0, 0, 0);
              overflow: hidden;
            }
          }

          .swiper-slide-active {
            transition: 200ms;
            transform: scale(1) !important;
            background: rgba(208, 235, 255, 0.28)
              linear-gradient(322deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                7deg,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
          }

          .swiper-slide-prev {
            //right: -4%;
            transition: 200ms;
            transform: scale(0.9) !important;
            background: rgba(255, 255, 255, 0.26);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
          }

          .swiper-slide-next {
            //left: -4%;
            transition: 200ms;
            transform: scale(0.9) !important;
            background: rgba(255, 255, 255, 0.26);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
          }
          .swiper-pagination-bigView {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 10;
          }
          .my-bullet {
            width: 26px;
            height: 8px;
            background: #c4c4c4;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin: 0 5px;
          }

          .my-bullet-active2 {
            background: #b4251e;
          }
        }
        .big-view-info-box {
          overflow: hidden;
          width: 100%;
          height: 634px;
          padding: 0 50px 25px 50px;
          //padding-left: 45px;
          background: url("../assets/images/bigView/bg-wap-kv.png"),
            url("../assets/images/bigView/bg-wap.png");
          background-position: top right, 0 0;
          background-repeat: no-repeat, no-repeat;
          background-size: 495px 219px, 100% 100%;
          position: relative;
          .bottom {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 495px;
            height: 200px;
            background: url("../assets/images/bigView/bottom-bg-wap.png");
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 495px 200px;
            z-index: 2;
          }
          .photo {
            width: 178px;
            position: absolute;
            left: 45px;
            top: 0;
            z-index: 1;
          }
          .name {
            margin-left: 178px;
            padding-top: 97px;
            font-size: 30px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #151e26;
          }
          .red-line {
            margin-top: -10px;
            margin-left: 178px;
            width: 104px;
            height: 5px;
            background: #b4251e;
            margin-bottom: 13px;
          }
          .position {
            margin-left: 178px;
            font-size: 22px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #888888;
            margin-right: -30px;
          }
          .viewpoint {
            margin-left: -20px;
            padding-left: 20px;
            //margin-top: 74px;
            padding-right: 20px;
            top: 254px;
            position: absolute;
            width: 464px;
            text-align: justify;
            word-break: break-all;
            text-justify: distribute;
            z-index: 3;
            font-size: 20px;
          }
        }
      }
    }
    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;
      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }
  }
}
</style>
